
export const parseAmount = (amount: string) => {
  return parseFloat(amount.replace(',', '.').replace(/\s/g, ''))
}
